import React from 'react';

// Catches render-time crashes in the editor area (e.g. a quest whose data the
// UI can't draw) and shows a recoverable message instead of a blank white page.
// The surrounding chrome (the quest menu) stays outside this boundary, so the
// user can still switch to another quest. `resetKey` lets the parent clear the
// error when the selected quest changes — a new quest gets a fresh attempt.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error && error.message ? error.message : String(error) };
  }

  componentDidCatch(error, info) {
    // Keep the details in the console for debugging; the UI stays friendly.
    console.error('Editor render error:', error, info);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false, message: '' });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '32px', maxWidth: 640, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ marginTop: 0 }}>⚠️ Couldn't display this quest</h2>
          <p style={{ color: '#666' }}>
            Something in this quest's data stopped the editor from rendering. The quest
            itself is safe in the database — switch to another quest from the menu, or
            reload the page.
          </p>
          {this.state.message && (
            <pre style={{
              textAlign: 'left', background: '#f6f8fa', padding: '10px 12px',
              borderRadius: 6, overflowX: 'auto', fontSize: 12, color: '#c0392b',
            }}>{this.state.message}</pre>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 12, padding: '10px 20px', border: 'none', borderRadius: 5,
              background: '#27ae60', color: '#fff', fontWeight: 'bold', cursor: 'pointer',
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
